// extracted by mini-css-extract-plugin
export default {"toggleWorkflowsSection":"workflows-container__toggle-workflows-section__lfYDx"};